import { render, staticRenderFns } from "./RetirementResourceStack.vue?vue&type=template&id=22f59684&scoped=true&"
import script from "./RetirementResourceStack.vue?vue&type=script&lang=js&"
export * from "./RetirementResourceStack.vue?vue&type=script&lang=js&"
import style0 from "./RetirementResourceStack.vue?vue&type=style&index=0&id=22f59684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f59684",
  null
  
)

export default component.exports